import { toast } from "react-toastify";
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import { Types } from '../reducers/statistics';
import { cloneDeep } from "utils/verifier";

//Synchronous

//Asynchronous
export const getGeneralStatistics = () => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstanceV2.get(serverRoutes.Statistics.general)
        .then((response) => {
            dispatch({
                type: Types.GENERAL_STATISTICS,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GENERAL_STATISTICS,
                payload: null
            });
        })
    }
}

export const getAppLayerStatisticsFilters = () => {
  return (dispatch) => {
      dispatch({
          type: Types.SET_LOADING_FILTERS
      });
      axiosInstance.get(serverRoutes.Statistics.appLayerStatisticsFilters,)
        .then((response) => {
          dispatch({
              type: Types.APP_LAYER_STATISTICS_FILTERS,
              payload: response.data
          })
      })
      .catch((err) => {
          console.log(err)
          dispatch({
              type: Types.APP_LAYER_STATISTICS_FILTERS,
              payload: null
          });
      })
  }
}

export const getAppLayerStatistics = (filters, enableLoading) => {
    return (dispatch) => {
        if (enableLoading) {
            dispatch({
                type: Types.SET_LOADING
            });
        } else {
            dispatch({
                type: Types.SET_LOADING_TOTAL_REQUISITIONS
            })
        }
      axiosInstance.get(serverRoutes.Statistics.appLayerStatistics({...filters}))
      .then((response) => {
          dispatch({
              type: Types.APP_LAYER_STATISTICS,
              payload: response.data
          })
      })
      .catch((err) => {
          console.log(err)
          dispatch({
              type: Types.APP_LAYER_STATISTICS,
              payload: null
          });
      })
  }
}

export const getStorageStatistics = (filters) => {
  return (dispatch) => {
      dispatch({
          type: Types.SET_LOADING
      });

      axiosInstance.get(serverRoutes.Statistics.storageStatistics({...filters}))
      .then((response) => {
          dispatch({
              type: Types.STORAGE_STATISTICS,
              payload: response.data
          })
      })
      .catch((err) => {
          console.log(err)
          dispatch({
              type: Types.STORAGE_STATISTICS,
              payload: null
          });
      })
  }
}

export const getStorageStatisticsFilters = () => {
  return (dispatch) => {
      dispatch({
        type: Types.SET_LOADING_FILTERS
      });
      axiosInstance.get(serverRoutes.Statistics.storageStatisticsFilters,)
        .then((response) => {
          dispatch({
              type: Types.STORAGE_STATISTICS_FILTERS,
              payload: response.data
          })
      })
      .catch((err) => {
          console.log(err)
          dispatch({
              type: Types.STORAGE_STATISTICS_FILTERS,
              payload: null
          });
      })
  }
}

export const getInjestorStatistics = (filters) => {
  const filterParams = cloneDeep(filters);
  if (filterParams.t.length) {
    filterParams.t[0].setHours(0, 0, 0, 0);
    filterParams.t[1].setHours(23, 59, 59, 999);
  }
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Statistics.injestorStatistics, {
      params: filterParams,
    }).then((response) => {
      dispatch({
        type: Types.INJESTOR_STATISTICS,
        payload: response.data
      })
    })
      .catch((err) => {
        console.log(err);
        toast.error("Erro ao buscar estatísticas do ingestor.", { autoClose: 10000 });
        dispatch({
          type: Types.INJESTOR_STATISTICS,
          payload: null
        });
      })
  }
}

export const getServiceLayerStatisticsUser = (username, period, dtsets, qtype) => {
  if (period && period.length) {
    period[0].setHours(0, 0, 0, 0);
    period[1].setHours(23, 59, 59, 999);
  }
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Statistics.serviceLayerStatisticsUser(username), {
      params: { period, dtsets, qtype, },
    })
      .then((response) => {
        dispatch({
          type: Types.SERVICE_LAYER_STATISTICS_USER,
          payload: response.data
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.SERVICE_LAYER_STATISTICS_USER,
          payload: null
        });
      })
  }
}
